// Shared Dionlovelle live song list.
// Used by /live (Song List modal) and /live/songs (full page).
// Kept in the order the artist provided. Deduped + typos fixed + casing standardized.

export const specialRequests = [
  "Request ANYTHING and I'll learn it in 2 minutes",
  'Request An Original Dionlovelle Song',
];

export const songs = [
  'Mario – Let Me Love You',
  'Chris Brown – Yo (Excuse Me Miss)',
  'Jeremih – Oui',
  'Ginuwine – Stingy',
  'Fleetwood Mac – Dreams',
  'Joji – Sanctuary',
  'James Blake – Overgrown',
  'Men I Trust – Show Me How',
  'Durand Jones & The Indications – Is It Any Wonder',
  'The Killers – Somebody Told Me',
  'The Killers – Mr. Brightside',
  "The Zombies – She's Not There",
  'Emmanuel Cortes – Amor',
  'Junior H – Nací Para Amarte',
  'Tuyo',
  'Michael Jackson – Leave Me Alone',
  'Michael Jackson – Rock With You',
  'Michael Jackson – Butterflies',
  'Michael Jackson – Human Nature',
  'Nick Hakim – Cuffed',
  'Nick Hakim – Needy Bees',
  'Nick Hakim – Green Twins',
  "Bryson Tiller – Don't",
  'Daniel Caesar & H.E.R. – Best Part',
  "Aaliyah – I Don't Wanna",
  'Daniel Caesar – Get You',
  'Daniel Caesar – Japanese Denim',
  'Justin Bieber – Confident',
  "Justin Bieber – You're All That Matters",
  'Sade – Your Love Is King',
  'Sade – Is It A Crime',
  'The-Dream – Love Your Girl',
  'The-Dream – Shawty Is a 10',
  'Destin Conrad – In The Air',
  'Ed Sheeran – Thinking Out Loud',
  'Vance Joy – Riptide',
  'Corinne Bailey Rae – Put Your Records On',
  'Lianne La Havas – No Room For Doubt',
  'People Make The World Go Round',
  'Lauryn Hill – Killing Me Softly',
  "Marvin Gaye – What's Going On",
  'Marvin Gaye – Sexual Healing',
  'Al Green – Still In Love',
  'Al Green – Tired Of Being Alone',
  "Al Green – Let's Stay Together",
  'Heatwave – Always And Forever',
  'The Chi-Lites – Have You Seen Her',
  "Bobby Caldwell – What You Won't Do For Love",
  'DeBarge – I Like It',
  'Chaka Khan – Sweet Thing',
  'Anita Baker – Sweet Love',
  'DeBarge – All This Love',
  'Diamond In The Back',
  'Malo – Suavecito',
  'Smokey Robinson – Ooh Baby Baby',
  "Smokey Robinson – Cruisin'",
  'Luther Vandross – Never Too Much',
  'Tower Of Power – So Very Hard To Go',
  'Tevin Campbell – Can We Talk',
  'Stan Getz – Girl From Ipanema',
  'The Temptations – My Girl',
];
